import axios from 'axios'

export default {
  methods: {
    openSeatMap (show, callback, shopId, propagated) {
      let $this = this
      // this.selectedSeats = []
      this.activeShow = show
      if (!propagated) {
        this.$socket.emit('message', {
          type: 'openSeatmap',
          data: show,
          shopId: this.$store.state.shopId,
          pos: this.$store.state.pos,
          clientId: this.$store.state.clientid
        })
      }
      axios.get(`${this.baseDomain}${shopId}/${this.locale}/resources/${show.resource_id}/seatmaps.json?start_ts=${show.start_ts}&end_ts=${show.end_ts}`)
      .then(function (response) {
        $this.seatMap = response.data
        $this.showSeatMap = true
        if (callback) {
          callback()
        }
      })
      .catch(function () {
        // No seat map, just buy the damn ticket
        this.buyTicketClicked(show)
      })
    },
    closeSeatMap (propagated) {
      this.activeShow = false
      this.showSeatMap = false
      this.selectedSeats = []
      this.seatTicketId = null
      if (!propagated) {
        this.$socket.emit('message', {
          type: 'closeSeatmap',
          data: false,
          shopId: this.$store.state.shopId,
          pos: this.$store.state.pos,
          clientId: this.$store.state.clientid
        })
      }
    },
    seatSelected (seatId) {
      this.selectedSeats.push(seatId)
    },
    seatDeselected (seatId) {
      let index = this.selectedSeats.indexOf(seatId)
      if (index !== -1) {
        this.selectedSeats.splice(index, 1)
      }
    },
    seatSelectionConfirmed (show, ticketId) {
      this.seatTicketId = ticketId || null // Ticket type chosen on the seatmap for every selected seat (JDEV-3439)
      if (this.selectedSeats.length) {
        this.participants = [this.selectedSeats.length]
        this.addShowToBasket(show)
        this.selectedSeats = []
      }
      this.closeSeatMap()
    }
  },
  mounted () {
    this.EventBus.$on('openSeatmap', (message) => {
      if (message.pos === this.$store.state.pos && message.shopId === this.$store.state.shopId && message.clientId !== this.$store.state.clientid) {
        if (!this.showSeatMap) {
          this.openSeatMap(message.data, false, message.shopId, true)
        }
      }
    })
    this.EventBus.$on('closeSeatmap', (message) => {
      if (message.pos === this.$store.state.pos && message.shopId === this.$store.state.shopId && message.clientId !== this.$store.state.clientid) {
        if (this.showSeatMap) {
          this.closeSeatMap(true)
        }
      }
    })
  }
}

/*

    openSeatMap (show) {
      let $this = this
      this.selectedSeats = []
      this.activeShow = show
      axios.get(`${this.baseDomain}${this.productShopId}/${this.locale}/resources/${show.resource_id}/seatmaps.json?start_ts=${show.start_ts}&end_ts=${show.end_ts}`)
      .then(function (response) {
        $this.seatMap = response.data
        $this.showSeatMap = true
      })
      .catch(function () {
        // No seat map, just buy the damn ticket
        this.buyTicketClicked(show)
      })
    },
    closeSeatMap () {
      this.activeShow = false
      this.showSeatMap = false
    },
    seatSelected (seatId) {
      this.selectedSeats.push(seatId)
    },
    seatDeselected (seatId) {
      let index = this.selectedSeats.indexOf(seatId)
      if (index !== -1) {
        this.selectedSeats.splice(index, 1)
      }
    },
    seatSelectionConfirmed (show) {
      if (this.selectedSeats.length) {
        this.participants = [this.selectedSeats.length]
        this.addShowToBasket(show)
        this.selectedSeats = []
      }
      this.closeSeatMap()
    },
*/